/**
 * Moving between the three screens.
 *
 * Docked at the bottom because that's where a thumb is, and labelled because
 * three icons alone would be a guessing game.
 */

import { Icon } from "./Icon";
import type { IconName } from "./Icon";

import "./NavBar.css";

export const TABS = ["kitchen", "recipes", "learn", "settings"] as const;
export type Tab = (typeof TABS)[number];

const TAB_LABELS: Record<Tab, string> = {
  kitchen: "Kitchen",
  recipes: "Recipes",
  learn: "Learn",
  settings: "Settings",
};

const TAB_ICONS: Record<Tab, IconName> = {
  kitchen: "fridge",
  recipes: "recipes",
  learn: "learn",
  settings: "settings",
};

interface NavBarProps {
  current: Tab;
  onSelect: (tab: Tab) => void;
}

export function NavBar({ current, onSelect }: NavBarProps) {
  return (
    <nav className="nav" aria-label="Sections">
      {TABS.map((tab) => (
        <button
          className="nav__tab"
          key={tab}
          type="button"
          aria-current={current === tab ? "page" : undefined}
          onClick={() => onSelect(tab)}
        >
          <Icon name={TAB_ICONS[tab]} className="nav__icon" />
          <span className="nav__label">{TAB_LABELS[tab]}</span>
        </button>
      ))}
    </nav>
  );
}
